import {Injectable} from '@angular/core';
import {io, Socket} from 'socket.io-client';

/**
 * dünner Wrapper um `io()`, damit Tests die Socket-Erzeugung per DI ersetzen können,
 * ohne das ES-Modul `socket.io-client` mocken zu müssen.
 */
@Injectable({
    providedIn: 'root'
})
export class SocketIoFactory {
    create(url: string, opts: Record<string, unknown>): Socket {
        return io(url, opts);
    }
}
